import { ADMIN_ORG } from "../../../constants";
import useOrgId from "./useOrgId";
import { useWorkspaceData } from "../../FpEditor/services/useWorkspaceData";
import { chatBackendKindForId } from "../../FpPages/Chat/selectChatBackend";

/**
 * Returns true when the workspace belongs to a different organization
 * than the current user. Returns false when either ID is unavailable
 * (new workspace, still loading, etc.) or when the workspace is an
 * admin template (ADMIN_ORG), which is intentionally editable across orgs.
 *
 * An agentic chat conversation id is not a workspace, so it is never read:
 * the read is certain to fail, and the answer is false either way (#12239).
 * The hook only reads the workspace's organization, so it does not re-read
 * a workspace another component on the page has already loaded.
 */
const useIsWrongOrg = (workspaceId?: string): boolean => {
  const userOrgId = useOrgId();
  const agentic =
    !!workspaceId && chatBackendKindForId(workspaceId) === "agentic";
  const { data: workspaceData } = useWorkspaceData(workspaceId, {
    enabled: !agentic,
    refetchOnMount: false,
  });
  if (agentic) return false;
  const workspaceOrgId = workspaceData?.organization_id;

  if (!userOrgId || !workspaceOrgId) return false;
  if (workspaceOrgId === ADMIN_ORG) return false;
  return userOrgId !== workspaceOrgId;
};

export default useIsWrongOrg;
